import { getCenterLocationState } from '../center/useCases/getCenterLocationState'
import transformTextToSlug from '../../utils/transformTextToSlug'

export const getInsuranceLink = (
  insuranceTitle: string,
  centerLocations: string[],
  tooltipLink: string
): string => {
  const centerLocationState = transformTextToSlug(
    getCenterLocationState(centerLocations)
  )
  const insuranceLinkPath = centerLocationState || 'insurance'

  if (insuranceTitle.includes('Medicare')) {
    return `/${insuranceLinkPath}/medicare/`
  }
  if (insuranceTitle.includes('Medicaid')) {
    return `/${insuranceLinkPath}/medicaid/`
  }
  return tooltipLink
}
